import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { homeHeroSwiper } from './slider';

gsap.registerPlugin(ScrollTrigger);

const refreshScrollTrigger = () => {
  ScrollTrigger.refresh();
};

const loadingAnimation = () => {
  const loading = document.querySelector('#js-loading');

  if (!loading) return;

  const logo = loading.querySelector('#js-loading-logo');
  const logoOutline = loading.querySelector('#js-loading-logo-outline');
  const outlinePath = logoOutline.querySelectorAll('path');

  let tl = gsap.timeline();

  tl.to(outlinePath, {
    duration: 2,
    strokeDashoffset: 0,
  })
    .to(logoOutline, {
      duration: .8,
      opacity: 0
    }, 'seen01')
    .to(logo, {
      duration: .8,
      opacity: 1
    }, 'seen01')
    .to(loading, {
      duration: .8,
      autoAlpha: 0,
      onComplete() {
        homeHeroSwiper().init();
      }
    });
};


const fadeUpAnimation = () => {
  const items = document.querySelectorAll('.js-fadeInItem');

  if (items.length === 0) return;

  items.forEach(item => {
    gsap.to(item, {
      duration: .8,
      opacity: 1,
      scrollTrigger: {
        trigger: item,
        start: 'top bottom-=10%',
        // markers: true,
        toggleActions: "play reset play reverse"
      }
    });
  });
};

export default () => {
  fadeUpAnimation();
  loadingAnimation();
};

export { refreshScrollTrigger };